import React, { useState, useRef, useEffect } from 'react'
import { withApi } from 'shared-ui/api/ApiContext'
import SwitchAppIcon from 'shared-ui/assets/img/switch-app-icon.svg'
import ConnexusIcon from 'shared-ui/assets/img/jti-connexus-icon.svg'
import B2XIcon from 'shared-ui/assets/img/b2x-app-icon.svg'

const ICON_MAP = {
  cnx: ConnexusIcon,
  b2x: B2XIcon,
}

const HeaderSwitchApp = props => {
  const { items = [] } = props

  const [open, setOpen] = useState(false)
  const wrapperRef = useRef(null)

  useEffect(() => {
    if (open) {
      document.body.classList.add('switch-app-dropdown-open')
    } else {
      document.body.classList.remove('switch-app-dropdown-open')
    }
    return () => document.body.classList.remove('switch-app-dropdown-open')
  }, [open])

  useEffect(() => {
    const handleClickOutside = e => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  if (!items?.length) return null

  const apps = items?.map(item => ({
    ...item,
    icon: ICON_MAP[item.value?.toLowerCase()] || item.icon || null,
  }))

  return (
    <div className="relative" ref={wrapperRef}>
      <div onClick={() => setOpen(!open)}>
        <SwitchAppIcon className="h-6 w-6 cursor-pointer text-gray-700" />
      </div>

      {open && (
        <div className="absolute right-0 z-[1001] mt-4 w-72 rounded-lg border border-gray-200 bg-gray-50 p-4 shadow-lg">
          <div className="flex w-full flex-wrap justify-center gap-8 rounded-md bg-white p-2">
            {apps?.map(app => (
              <a
                key={app.value}
                href={app?.url}
                className="flex flex-col items-center text-center text-sm transition hover:opacity-90"
              >
                <div className="h-16 w-16">
                  {typeof app.icon === 'string' ? (
                    <img src={app.icon} alt={app.value} className="h-6 w-6" />
                  ) : (
                    app.icon && <app.icon className="h-16 w-16 text-white" />
                  )}
                </div>
                <span className="mt-2 font-medium text-gray-800">{app.label}</span>
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default withApi(HeaderSwitchApp)
